
define('modules/application/wizard/classes/pumps',[
  "app",

  // Libs
  "backbone",

  //Classes
  "./genericIncrementalElement"

],

function(app, Backbone, genericIncrementalElement) {

  var pump   = _.extend({}, genericIncrementalElement, {

    Views : {
      titleBar  : genericIncrementalElement.Views.titleBar.extend({
        template: "application/wizard/sections/pumps/titleBar",
        events : {
          "click" : "titleBarClickedEventHandler"
        },
        titleBarClickedEventHandler : function(e) {
          this.model.trigger("tooltips:toggle");
        },
        afterRender  :  function() {
          var that = this;
          this.$el.children(".titleBarcontent").prepend($.i18n._("IDS_WTR1_205"));
        },
        setLabel                      : function() {
          if ((this.model.get("value")!==null)&&(this.model.get("value")>0))
          {
            this.$el.find(".caption").html($.i18n._("IDS_WTR1_205_SUB")+": "+this.model.get("value"));
            this.$el.find(".caption").fadeIn(200);
          }
          else
            this.$el.find(".caption").fadeOut(200, function() {$(this).hide();});
        }
      }),
      
      content   : genericIncrementalElement.Views.content.extend({

        events : _.extend({
          "click .toggleInfoButton" : "toggleInfos"
        }, genericIncrementalElement.Views.content.prototype.events),

        initialize                             : function() {
          genericIncrementalElement.Views.content.prototype.initialize.apply(this);

          this.model.unbind("tooltips:toggle", this.tooltipToggleRequestedEventHandler);
          this.model.bind("tooltips:toggle", this.tooltipToggleRequestedEventHandler, this);

          // this.model.getPackages();
        },

        toggleInfos : function(e) {
          return genericIncrementalElement.Views.content.prototype.toggleInfos(e, this);
        },

        afterRender                           : function() {
          var that = this;
          genericIncrementalElement.Views.content.prototype.afterRender.apply(this);

          if ((this.model.get("wizardChoiceLabel"))&&(this.model.get("wizardChoiceLabel")!==""))
            this.$el.find(".title.mainElement").html($.i18n._("IDS_WTR1_205_SUB"));
        }
      })
    },

    Model       : genericIncrementalElement.Model.extend({

      defaults : _.extend({
        infoQuote : "IDS_WGENTT_000004",
        maxValue        : 9
      }, genericIncrementalElement.Model.prototype.defaults),

      initialize    : function() {
        var that = this;

        this.set("maxValue", 9);

        //Bind on accessory line selection
        window.BticinoS4B.eventAggregator.unbind('accessoryLine:chosen', this.getPackages);
        window.BticinoS4B.eventAggregator.bind('accessoryLine:chosen', this.getPackages, this);
        genericIncrementalElement.Model.prototype.initialize.apply(this);
      },

      deliverModel  : function() {

          switch (BticinoS4B.vars.system.id) {
            case '#2':
              BticinoS4B.solution.thermoregulation.pumps = this;
              break;
            case '#4':
              BticinoS4B.solution.intrusionDetection.pumps = this;
              break;
            case '#5+6':
              BticinoS4B.solution.audioVideo.pumps = this;
              break;
            case '#13+20':
              BticinoS4B.solution.automation.pumps = this;
              break;
            case '#13':
              BticinoS4B.solution.automationSimple.pumps = this;
              break;
            case '#21':
              BticinoS4B.solution.energyManagement.pumps = this;
              break;
          }
        BticinoS4B.Instances.Models.ApplicationModel.set("pumps", this);
        var dataProvider = BticinoS4B.Instances.Models.ApplicationModel.get("wizardModel").get("dataProvider"),
            i            = 0;

        dataProvider.addItems("externalItems", {
          productCode       : this.get("productCode"),
          productLabel      : this.get("productLabel"),
          packageClassLabel : this.get("packageClassLabel"),
          kitValue          : this.get("kitValue"),
          partOfKit         : this.get("partOfKit"),
          quantity          : this.get("value"),
          price             : this.get("price")
        });

        if (this.get("secondaryProducts"))
        {
          for (i=0; i<this.get("secondaryProducts").length; i++)
          {
            dataProvider.addItems("externalItems", {
              productCode       : this.get("secondaryProducts")[i].productCode,
              productLabel      : this.get("secondaryProducts")[i].productLabel,
              packageClassLabel : this.get("secondaryProducts")[i].packageClassLabel,
              kitValue          : this.get("kitValue"),
              partOfKit         : this.get("partOfKit"),
              quantity          : this.get("value"),
              price             : this.get("secondaryProducts")[i].price
            });
          }
        }
      },

      getPackages   :  function() {
        var that = this;
        BticinoS4B.Instances.Models.ApplicationModel.getPackagesByIdWizardChoice("205", function(data) {

          //Sorting elements by packageClassId
          that.fetchedPumps = data.packages;

          var currentpackageClassid = "-1";
          for (var i = 0; i<that.fetchedPumps.length; i++)
          {
            if (currentpackageClassid!==that.fetchedPumps[i].packageClassId)
              currentpackageClassid = that.fetchedPumps[i].packageClassId;
            else
            {
              that.fetchedPumps.splice(i,1);
              i--;
            }
          }

          _.extend(that.attributes, that.fetchedPumps[0]);

          //Retrieving product details
          BticinoS4B.Instances.Models.ApplicationModel.getProducts(that.get("packageClassId"), function(data) {
            data.products          = BticinoS4B.Instances.Models.ApplicationModel.filterProductsByCatalogAndWizardChoices(data.products);
            var mainProduct        = _.filter(data.products,function(product) {return (product.mnemonic===1);});
            var secondaryProducts  = _.filter(data.products,function(product) {return (product.mnemonic!==1);});

            if (mainProduct.length>0)
              mainProduct=mainProduct[0];

            _.extend(that.attributes, mainProduct);
            that.set("secondaryProducts", secondaryProducts);

            that.trigger("render:requested");
          });
        });
      },

      loadProject   : function(model) {
        if (!model.pumps)
          model.pumps = 0;
        this.set("value", model.pumps);
        this.trigger("updateViews");
      }

    })
  });
  // Required, return the module for AMD compliance
  return pump;

});